import httpInterceptor from '../helpers/httpInterceptor';
const PRODUCT_END_POINT = process.env.REACT_APP_PRODUCT_API_ENDPOINT;

export default {
  // FIRST TIME CALL AT PRODUCT PAGE 
  getProducts(params, pageLimit, onlyInconsistence, priceNotIn) {
    let queryParams = `limit=${pageLimit}`;
    if(priceNotIn) {
      queryParams = queryParams + `&prices_not_in=${priceNotIn}`;
    }
    // return httpInterceptor.get(PRODUCT_END_POINT + `multicurrency_products${params ? (params.query ? '': `?${queryParams}`) : `?${queryParams}`}`, {
    //   params
    // })
    return httpInterceptor.get(PRODUCT_END_POINT + `multicurrency_products`, {
      params: {
        ...params,
        limit: pageLimit,
        ...(priceNotIn && { prices_not_in: priceNotIn })
      }
    })
  },
  updateProducts(putData) {
    return httpInterceptor.put(PRODUCT_END_POINT + 'multicurrency_products', putData)
  },
  getProductCount(params, onlyInconsistence = false, priceNotIn = '') {
    // let queryParams = `only_inconsistent=${onlyInconsistence}`;
    let queryParams="";
    if(priceNotIn) {
      queryParams = `prices_not_in=${priceNotIn}`;
    }
    return httpInterceptor.get(PRODUCT_END_POINT + `multicurrency_products/count?${queryParams}`, {
      params
    })
  },
  removeVariants(params) {
    return httpInterceptor.delete(PRODUCT_END_POINT + 'multicurrency_products?ids=all', {
      params
    })
  },
  refreshProducts(storeName){
    return httpInterceptor.get(PRODUCT_END_POINT + `multicurrency_products_refresh?shop=${storeName}`)
  },
  getShopProductUniques() {
    return httpInterceptor.get(PRODUCT_END_POINT + 'shop-product-uniques');
  },
  removeNonPrimaryPrices(payload) {
    return httpInterceptor.post(
      PRODUCT_END_POINT + 'multicurrency_products/remove-non-primary-prices',
      payload,
    );
  },
}